






















































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import CreateCompanyInformation from './create-companyinformation.vue'
    import Editcompanyinformation from './edit-companyinformation.vue'
    import ORD from './ord.vue'   
     //export default class EditUser extends AbpBase{
   
    class PagecompanyinformationRequest extends PageRequest{
        keyword:string='';
        ordtime:[];
        province:string='';
        city:string='';
        county:string='';
        villages:string='';

    }
    
    @Component({
        components:{CreateCompanyInformation,Editcompanyinformation,ORD}
    })
    
    export default class companyinformations extends AbpBase{
        edit(){
            this.editModalShow=true;
        }
        ordsw(id:number){
        this.ordShow=true;
        this.cid=id;
        
        }
       

        pagerequest:PagecompanyinformationRequest=new PagecompanyinformationRequest();
        cid:number
        createModalShow:boolean=false;
        editModalShow:boolean=false;
        ordShow:boolean=false;
       //  citylist:Object
        get list(){
            
            return this.$store.state.companyinformation.list;
        };
        get loading(){
            return this.$store.state.companyinformation.loading;
        }
        create(){
            this.createModalShow=true;
        }
        pageChange(page:number){
            this.$store.commit('companyinformation/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('companyinformation/setPageSize',pagesize);
            this.getpage();
        }
        async GetRegionAlList(){
            
            
            await this.$store.dispatch({
                type:'companyinformation/getRegionAlList',
                 
            })
        }
        async getpage(){
           
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            
            await this.$store.dispatch({
                type:'companyinformation/getAll',
                data:this.pagerequest
            })
        }

        
        
        get provicelist(){
             var list=[];
             var lets  = this.$store.state.companyinformation.regionlist;

              
               
           
            if(lets!=undefined&&lets.length>0){
               for(var i=0;i<lets.length;i++){
                  
               var province= lets[i].province;
                list.push(province);
                      
               }
               }
          return list;
        }
        get citylist(){
            return  this.$store.state.companyinformation. citylist
        }
        set citylist(val:object){

                this.$store.commit("companyinformation/change_citylist", val);
        }

        get countylist(){
                return  this.$store.state.companyinformation. countylist
        }
        set countylist(val:object){

                this.$store.commit("companyinformation/change_countylist", val);
        }
         get villageslist(){
                return  this.$store.state.companyinformation. villageslist
        }
        set  villageslist(val:object){

                this.$store.commit("companyinformation/change_villageslist", val);
        }

        

         provinceChange(val:number){
            this.$store.state.citylist=[];
            var selectedprovince= val;
            var list=[];
            var lets  = this.$store.state.companyinformation.regionlist;
            console.log(lets)
               for(var i=0;i<lets.length;i++){
                  
                 var province= lets[i].province;
                if(selectedprovince==province){
                       var lstct=lets[i].citylist;
                        lstct.forEach(item=>{
                            list.push( item.city)
                        });
                         

                }
               }
                
                this.citylist=list;       
         }

          cityChange(val:number){
            this.$store.state.county=[];
            var selectedvue= val;
            var list=[];
            var lets  = this.$store.state.companyinformation.regionlist;
            console.log(lets)
               for(var i=0;i<lets.length;i++){
                  
                 var province= lets[i].province;
                
                       var lstct=lets[i].citylist;
                        lstct.forEach(item=>{
                             
                             var city=item.city;
                             if(selectedvue==city){
                             var countylist=item.countylist;
                            countylist.forEach(item_county=>{
                                    var county=item_county.county;
                                    list.push(county);
                                      
                            });
                             }
                        });
                         

                
               }
               
                
                this.countylist=list;       
         }

           countyChange(val:number){
            this.$store.state.county=[];
            var selectedvue= val;
            var list=[];
            var lets  = this.$store.state.companyinformation.regionlist;
            console.log(lets)
               for(var i=0;i<lets.length;i++){
                  
                 var province= lets[i].province;
                
                       var lstct=lets[i].citylist;
                        lstct.forEach(item=>{
                             
                             var city=item.city;
                           
                             var countylist=item.countylist;
                            countylist.forEach(item_county=>{

                                    var county=item_county.county;
                                    var villageslist=item_county.villageslist;
                                    if(selectedvue==county){
                                        villageslist.forEach(item_vill=>{

                                         list.push(item_vill.villages);
                                        })

                                    }
                            });
                             
                        });
                         

                
               }
                
                
                this.villageslist=list;       
         }
        

    
        get pageSize(){
            return this.$store.state.companyinformation.pageSize;
        }
        get totalCount(){
            return this.$store.state.companyinformation.totalCount;
        }
        get currentPage(){
            return this.$store.state.companyinformation.currentPage;
        }
        columns=[
            {
　　width: 80, align: 'center', title: '序号', render: (h, params) => {
　　　　return h('span', params.index + (this.currentPage - 1) * this.pageSize + 1);
　　}
},
            
            {
            title:this.L('CompanyinformationName'),
            key:'name'
        },{
            title:this.L('CompanyinformationProvince'),
            key:'province'
        },{
            title:this.L('CompanyinformationCity'),
            key:'city'
        },{
            title:this.L('CompanyinformationCounty'),
            key:'county'
        },{
            title:this.L('CompanyinformationVillages'),
            key:'villages'
        }
        
       ,{
            title:this.L('Actions'),
            key:'Actions',
            width:300,
            render:(h:any,params:any)=>{
                return h('div',[
                    h('Button',{
                        props:{
                            type:'primary',
                            size:'small'
                        },
                        style:{
                            marginRight:'5px'
                        },
                        on:{
                            click:()=>{
                                this.$store.commit('companyinformation/edit',params.row);
                                this.edit();
                            }
                        }
                    },this.L('Edit')),
                    
                    h('Button',{
                        props:{
                            type:'primary',
                            size:'small'
                        },
                        style:{
                            marginRight:'5px'
                        },
                        on:{
                            click:()=>{
                              //  this.$store.commit('companyinformation/edit',params.row);
                                var id=params.row.id;
                                this.ordsw(id);
                                
                                  
                            }
                        }
                    },this.L('CinfoOrderDetail')),
                    h('Button',{
                        props:{
                            type:'error',
                            size:'small'
                        },
                        on:{
                            click:async ()=>{
                                this.$Modal.confirm({
                                        title:this.L('Tips'),
                                        content:this.L('DeleteConfirm'),
                                        okText:this.L('Yes'),
                                        cancelText:this.L('No'),
                                        onOk:async()=>{
                                            await this.$store.dispatch({
                                                type:'companyinformation/delete',
                                                data:params.row
                                            })
                                            await this.getpage();
                                        }
                                })
                            }
                        }
                    },this.L('Delete'))
                ])
            }
        }]
         async created(){
            this.GetRegionAlList()
            this.getpage();
            
        }
         
    }
